import { useEffect } from 'react';
import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';

import { TAPIResponseApplicationAttributeLaunchTypes } from './application-launch-types.types';

type TUseAPIFetchApplicationLaunchTypesOptions = {
  silence?: boolean;
};

export const useAPIFetchApplicationLaunchTypes = (
  options?: TUseAPIFetchApplicationLaunchTypesOptions
): TAPIResponseApplicationAttributeLaunchTypes => {
  const { get, response, loading, error, data } = useFetch(
    API_ROUTES.APPLICATIONS
  );

  const fetchApplicationLaunchTypes = async (): Promise<void> => {
    const { data } = await get('/application-launch-types');

    return data?.items || [];
  };

  useEffect(() => {
    if (!options?.silence) {
      fetchApplicationLaunchTypes();
    }
    // eslint-disable-next-line
  }, []);

  return {
    data: data?.data?.items || [],
    loading,
    loaded: response.ok,
    error,
    fetchApplicationLaunchTypes,
  };
};
